<template>
  <div class="form-group">
    <h3>Step {{ currentStep }}. Your {{ config.org_label || "organization" }} details</h3>
    <div class="infomsg" v-html="config.org_welcome || `Please use the <u>participant's</u> email address that is on file with ${config.org_label || 'the organization'}. This connects your flights to your program and any available vouchers or discounts.`"></div>

    <LanderProgramSelect :category="config.category" :program-id="programId" @update:program-id="$emit('update:programId', $event)" />

    <div class="form-row">
      <input :value="email" type="email" maxlength="100" required placeholder="Email address" @input="$emit('update:email', $event.target.value)" />
    </div>

    <LanderVoucher v-if="email && organizationId" :email="email" :organization-id="organizationId" @update:blocked="$emit('update:voucherBlocked', $event)" />

    <div v-if="showNameField" class="form-row">
      <input :value="name" type="text" maxlength="100" required :placeholder="(config.org_label || 'Organization') + ' participant full name'" @input="$emit('update:name', $event.target.value)" />
    </div>
  </div>
</template>

<script setup>
import { computed } from "vue";
import LanderProgramSelect from "./LanderProgramSelect.vue";
import LanderVoucher from "./LanderVoucher.vue";

const props = defineProps({
  config: {
    type: Object,
    required: true,
  },
  currentStep: {
    type: Number,
    required: true,
  },
  email: {
    type: String,
    default: "",
  },
  programId: {
    type: [String, Number],
    default: "",
  },
  name: {
    type: String,
    default: "",
  },
  organizationId: {
    type: Number,
    default: null,
  },
});

defineEmits(["update:email", "update:programId", "update:name", "update:voucherBlocked"]);

const showNameField = computed(() => {
  return !props.config.features?.is_traveler_shown;
});
</script>
